<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <!-- dialog common header -->
    <popup-header v-on:clickClose="closeModal()"></popup-header>

    <!-- 제목 -->
    <div>
      <v-row class="title-wrap">
        <v-col cols="12" class="icon-title word-type d-flex align-self-center">
          <icon-pay-detail :width="24" :height="24" />
          <div>
            {{ payCardParam.paymentMonth }}월 급여명세서
            <div class="pay-date">{{ payCardParam.payActionNm }}</div>
          </div>
          <v-btn
            @click="openModal()"
            elevation="0"
            color="#ffffff"
            class="ml-auto btn-payCalc"
          >
            급여 계산방법
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="ma-0 overflow-y-auto">
        <v-col cols="12" class="pa-0 pay-sheet-wrap">
          <v-sheet class="pay-sheet">
            <v-row class="ma-0">
              <v-col
                cols="12"
                class="px-6 py-0 d-flex justify-space-between pay-list"
              >
                <div>
                  <span class="label">지급총액</span>
                  <span class="chips-wrap">
                    <v-chip label class="blue">실수령액</v-chip>
                  </span>
                </div>
                <span class="desc big">
                  {{ payCardParam.paymentMon | comma }}
                </span>
              </v-col>
            </v-row>
          </v-sheet>

          <!-- 급여명세서 상세내용 -->
          <!-- [ 지급내역 ] -->
          <v-sheet class="pay-sheet">
            <v-row class="ma-0">
              <v-col cols="12" class="px-6 pt-0 pb-5 sheet-title"
                >지급내역</v-col
              >
            </v-row>
            <v-list class="pay-list" flat>
              <v-list-item-group>
                <v-list-item
                  :ripple="false"
                  v-for="(item, i) in payList"
                  :key="i"
                >
                  <v-list-item-content class="label" v-text="item.reportNm">
                  </v-list-item-content>
                  <v-list-item-content
                    class="desc justify-end"
                    v-text="item.resultMon"
                  >
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <v-row class="ma-0 line-wrap">
              <v-col cols="12" class="line"> </v-col>
            </v-row>
            <v-row class="ma-0 py-3">
              <v-col
                cols="12"
                class="px-6 py-0 d-flex justify-space-between pay-list"
              >
                <span class="label">총 지급액</span>
                <span class="desc">{{ totPayMon }}</span>
              </v-col>
            </v-row>
          </v-sheet>

          <!-- [ 공제내역 ] -->
          <v-sheet class="pay-sheet">
            <v-row class="ma-0">
              <v-col cols="12" class="px-6 pt-0 pb-5 sheet-title"
                >공제내역</v-col
              >
            </v-row>
            <v-list class="pay-list" flat>
              <v-list-item-group>
                <v-list-item
                  :ripple="false"
                  v-for="(item, i) in dedList"
                  :key="i"
                >
                  <v-list-item-content class="label" v-text="item.reportNm">
                  </v-list-item-content>
                  <v-list-item-content
                    class="desc justify-end"
                    v-text="item.resultMon"
                  >
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <v-row class="ma-0 line-wrap">
              <v-col cols="12" class="line"> </v-col>
            </v-row>
            <v-row class="ma-0 py-3">
              <v-col
                cols="12"
                class="px-6 py-0 d-flex justify-space-between pay-list"
              >
                <span class="label">총 공제액</span>
                <span class="desc">{{ totDedMon }}</span>
              </v-col>
            </v-row>
          </v-sheet>

          <!-- [ 계좌정보 ] -->
          <v-sheet class="pay-sheet pt-5">
            <v-row class="ma-0">
              <v-col
                cols="12"
                class="px-6 py-0 d-flex justify-space-between pay-list"
              >
                <span class="label align-self-center">입금계좌</span>
                <div class="text-right align-self-center">
                  <div class="label small">{{ accInfo.bankCdNm }}</div>
                  <div class="desc">{{ accInfo.accountNo }}</div>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>

      <!---------------------------------------------------------------------------->
      <!-- [모달] 급여명세서 계산방법 상세 -->
      <pay-calc-detail-dialog :payActionCdParam="payActionCdParam" />
    </div>
  </v-dialog>
</template>

<script>
/* 급여명세서(상세) 모달 */
import PopupHeader from '@/components/common/PopupHeader.vue';
import IconPayDetail from '@/assets/customIcon/IconPayDetail.vue';
import PayCalcDetailDialog from '@/components/pay/dialog/PayCalcDetailDialog.vue';
import { getPayEleList, getPayAccInfo } from '@/api/payStatus.js';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **

export default {
  mixins: [dialogMixin],

  props: {
    payCardParam: {
      type: Object,
    },
  },

  data: () => ({
    modalName: 'pay_detail',
    payActionCdParam: '',

    payDedList: [], // 지급공제목록
    accInfo: {}, // 계좌정보
  }),

  watch: {
    payCardParam() {
      this.fetchPayEleList();
      this.fetchPayAccInfo();
    },
  },

  computed: {
    dedList() {
      return this.payDedList.filter(item => item.gubun === 'DEDUCT');
    },
    payList() {
      return this.payDedList.filter(item => item.gubun === 'PAY');
    },
    totDedMon() {
      const data = this.payDedList.filter(
        item => item.gubun === 'DEDUCT_TOT',
      )[0];
      return data == undefined ? '0' : data.resultMon;
    },
    totPayMon() {
      const data = this.payDedList.filter(item => item.gubun === 'PAY_TOT')[0];
      return data == undefined ? '0' : data.resultMon;
    },
  },

  filters: {
    // 금액 콤마처리
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },

  methods: {
    openModal() {
      this.payActionCdParam = this.payCardParam.payActionCd;
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'pay_calc_detail');
    },

    /* 급여명세서 항목조회 */
    async fetchPayEleList() {
      try {
        const response = await getPayEleList({
          searchPayActionCd: this.payCardParam.payActionCd,
        });
        const dataList = response.data.data;

        if (response != null && dataList != null) {
          this.payDedList = dataList;
        }
      } catch (error) {
        console.log(error);
      }
    },
    /* 급여계좌정보 조회 */
    async fetchPayAccInfo() {
      try {
        const response = await getPayAccInfo();
        const dataList = response.data.data;
        this.accInfo = dataList[0];
      } catch (error) {
        console.log(error);
      }
    },
  },

  components: {
    PopupHeader,
    IconPayDetail,
    PayCalcDetailDialog,
  },
};
</script>
